import gql from "graphql-tag";

export const importPersonSubjectScore = gql`
    mutation ImportPersonSubjectScore($data: [ImportPersonSubjectScoreInput]) {
        importPersonSubjectScore(data: $data)
    }
`;
